module.exports = __webpack_public_path__ + "static/img/3.24177cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hw/3.jpg
// module id = hLKS
// module chunks = 0